import { reviewsApi, type ReviewsApiResponse, type SearchType } from '../slices/reviewsApi';
import { initialState } from '../slices/reviewsSearchFilters';
import type { SortOption } from '../types/Reviews';
import getSearchReviewsArg, { DEFAULT_SORT_OPTION } from './getSearchReviewsArg';

type UpsertInitialSearchReviewsParams = {
  perPage: number;
  reviews: ReviewsApiResponse;
  searchType: SearchType;
  sortOption?: SortOption;
};

/**
 * Seeds the RTK Query cache with a reviews response already fetched on the server, so
 * `SearchFilterReviews` has data on its first render and never issues a duplicate request.
 *
 * `upsertQueryEntries` is a plain action rather than a thunk, so dispatch this while the store is
 * being built. Dispatching from an effect lands after the first render has already committed.
 */
const upsertInitialSearchReviews = ({ perPage, reviews, searchType, sortOption = DEFAULT_SORT_OPTION }: UpsertInitialSearchReviewsParams) =>
  reviewsApi.util.upsertQueryEntries([
    {
      arg: getSearchReviewsArg({ facets: initialState.permanent, perPage, searchType, sortOption }),
      endpointName: 'searchReviews',
      value: reviews
    }
  ]);

export default upsertInitialSearchReviews;
